/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationProperties200ResponseMeta } from './GetOrganizationProperties200ResponseMeta';
import {
    GetOrganizationProperties200ResponseMetaFromJSON,
    GetOrganizationProperties200ResponseMetaFromJSONTyped,
    GetOrganizationProperties200ResponseMetaToJSON,
    GetOrganizationProperties200ResponseMetaToJSONTyped,
} from './GetOrganizationProperties200ResponseMeta';
import type { ContactOrganization } from './ContactOrganization';
import {
    ContactOrganizationFromJSON,
    ContactOrganizationFromJSONTyped,
    ContactOrganizationToJSON,
    ContactOrganizationToJSONTyped,
} from './ContactOrganization';

/**
 * 
 * @export
 * @interface ContactOrganizationsResponse
 */
export interface ContactOrganizationsResponse {
    /**
     * 
     * @type {Array<ContactOrganization>}
     * @memberof ContactOrganizationsResponse
     */
    contactOrganizations: Array<ContactOrganization>;
    /**
     * 
     * @type {GetOrganizationProperties200ResponseMeta}
     * @memberof ContactOrganizationsResponse
     */
    meta?: GetOrganizationProperties200ResponseMeta;
}

/**
 * Check if a given object implements the ContactOrganizationsResponse interface.
 */
export function instanceOfContactOrganizationsResponse(value: object): value is ContactOrganizationsResponse {
    if (!('contactOrganizations' in value) || value['contactOrganizations'] === undefined) return false;
    return true;
}

export function ContactOrganizationsResponseFromJSON(json: any): ContactOrganizationsResponse {
    return ContactOrganizationsResponseFromJSONTyped(json, false);
}

export function ContactOrganizationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactOrganizationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contactOrganizations': ((json['contactOrganizations'] as Array<any>).map(ContactOrganizationFromJSON)),
        'meta': json['meta'] == null ? undefined : GetOrganizationProperties200ResponseMetaFromJSON(json['meta']),
    };
}

export function ContactOrganizationsResponseToJSON(json: any): ContactOrganizationsResponse {
    return ContactOrganizationsResponseToJSONTyped(json, false);
}

export function ContactOrganizationsResponseToJSONTyped(value?: ContactOrganizationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactOrganizations': ((value['contactOrganizations'] as Array<any>).map(ContactOrganizationToJSON)),
        'meta': GetOrganizationProperties200ResponseMetaToJSON(value['meta']),
    };
}

